import gql from 'graphql-tag'
export default gql`
  mutation updateToaster ($key: String!, $value: String!, $merge: Toaster) {
    updateToaster(key: $key, value: $value, merge: $merge) @client
  }
`
